import React from 'react';
import CookieBot from "react-cookiebot";
import { CookiePolicyBannerProps } from "./fields.definitions";
import { CookiePolicyBannerModel } from './fields.model';

const CookiePolicyBanner = (props : CookiePolicyBannerProps) => {
  const model = new CookiePolicyBannerModel(props)
  return <CookieBot domainGroupId={model.CBID} language={model.culture} />
}

export default CookiePolicyBanner;
